/**
 * LifeRamp
 *
 * @author      Ummar Hamid
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */

import React from "react";
import { FlatList, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";

import { GlobalStyles } from "../../../themes/styles";
import { SpacingH } from "../../../themes/sizes";
import { Colors } from "../../../themes/colors";
import PlaceHolder from "../../../components/utils/PlaceHolder";
import SessionCard from "../../../components/cards/SessionCard";

import { CoachingSessions } from "../../../api";

export default ({ navigation, route }) => {
    const dispatch = useDispatch();

    const state = useSelector(state => state.coachingSession);
    const upcomingSessions = useSelector(state => state.coachingSession.upcomingSessions);

    const client = route.params?.client || false;

    React.useEffect(() => {
        dispatch(CoachingSessions.refreshUpcomingSessions());
    }, []);

    const loadMore = () => {
        if (state.loading) return;
        state.upcomingPage <= state.upcomingMaxPage && dispatch(CoachingSessions.getUpcomingSessions({ page: state.upcomingPage }));
    };

    let filteredUpcomingSessions = client !== false ? upcomingSessions.filter(u => u.user.uuid === client.uuid) : upcomingSessions;
    filteredUpcomingSessions = filteredUpcomingSessions.filter(s => s.status !== "cancelled" && s.status !== "rescheduled");

    return (
        <View style={{ flex: 1, backgroundColor: Colors.WHITE, paddingVertical: SpacingH.s2 }}>
            <FlatList
                data={filteredUpcomingSessions}
                onRefresh={() => dispatch(CoachingSessions.refreshUpcomingSessions())}
                refreshing={(state.refreshing || state.loading) && !state.autoLoading}
                onEndReached={loadMore}
                renderItem={({ item }) => <SessionCard {...item} style={GlobalStyles.containerMarginH} navigation={navigation} />}
                ListEmptyComponent={<PlaceHolder style={GlobalStyles.containerMarginH} status={(state.refreshing || state.loading)} repeat={4} type={"regularCard"} />}
                keyExtractor={item => item.uuid}
            />
        </View>
    );
};
